/**
 * vendor-dompurify.js — self-hosted DOMPurify (MPE-557).
 *
 * Replaces the cdnjs <script> that carried integrity/crossorigin/
 * referrerpolicy. Subresource Integrity exists to prove a THIRD-PARTY host
 * served the bytes we expected; once the file ships from our own origin
 * through the hashed-asset pipeline there is no third party left to
 * distrust, and the content hash in the filename plus the build itself take
 * over that job. The `integrity` attribute is therefore intentionally gone,
 * not accidentally dropped.
 *
 * Must still evaluate BEFORE app.js so `window.DOMPurify` is defined when
 * feature scripts run. The fail-closed fallbacks in app.js
 * (_sanitizeFormattedHTML) and chat-widget.js (sanitizeUserHTML) are
 * unchanged: if this file ever fails to load they still drop to
 * `textContent`.
 */
import DOMPurify from 'dompurify';

window.DOMPurify = DOMPurify;
